import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SharedService {

  private messageSource = new BehaviorSubject(' ');
  currentUrlFlag = this.messageSource.asObservable();

  constructor(
    private router: Router
  ) { }


  changeMessage(message: string) {
    this.messageSource.next(message);
  }

  // Return SessionID from localstorage ** to be changed with the object name **.
  sessionId() {
    return localStorage.getItem('sessionId');
  }

  // Return Username from localstorage ** to be changed with the object name **.
  userProfile() {
    return localStorage.getItem('username');
  }

  // Clear localstorage ** to be changed with the object name **.
  logout() {
    localStorage.removeItem('sessionId');
    localStorage.removeItem('username');
    this.router.navigate(['/']);
  }

}